module.exports = __webpack_public_path__ + "img/location.2f9dcaac.svg";